<template>
<section class="bg-white border-bottom">	
	<div @click="toggleDetails()" class="text-gray-500 text-uppercase font-weight-bold px-4 py-25 bg-gray-100 cursor-pointer">
		<i class="fal fa-fire-alt fa-fw mr-1"></i> Your Campaigns <i class="fas" :class="showDetails == false ? 'fa-caret-right' : 'fa-caret-down'"></i>
	</div>
	<div  class="px-4 py-25">
		<div @click="toggleDetails()" class="d-flex pb-2 border-bottom" style="border-bottom: 1px solid #e4e5e6">
			<div class="flex-fill text-center">
				<span class="text-3xl leading-none">{{ activeCampaigns.length ? activeCampaigns.length : '0' }}</span><br>
				<span class="text-sm text-gray-500 leading-tight">Active Campaigns</span>
			</div>
			
			<div class="flex-fill text-center" style="line-height:24px">
				<span class="text-3xl leading-none">{{ completedCampaigns.length  ? completedCampaigns.length : '0' }}</span><br>
				<span class="text-sm text-gray-500 leading-tight">Recently Completed</span>
			</div>
		</div>

		<div class="pt-2 pb-2" v-if="showDetails" style="border-bottom:1px solid #e4e5e6">
			<div v-if="options.campaigns.length < 1">
				No campaigns found.
			</div>

			<div class="py-2" v-else v-for="campaign in activeCampaigns.slice(-5)">
				<div class="d-flex">
					<router-link :to="{ name: 'campaigns.show', params: { id: campaign.id } }" class="flex-grow-1">{{ campaign.title }}</router-link>
					<div class="text-right">
						<span class="text-right">
							<strong>{{ Math.floor((campaign.progress/100) * campaign.visits.length) }}</strong>
							<span class="text-gray-500">/ {{ campaign.visits.length }} visits</span>
						</span>
					</div>
				</div>
				<div class="progress progress-xs">
					<div class="progress-bar" :class="moment(campaign.complete_by) < current ? '' : 'bg-success'" role="progressbar" :style="'width:' + campaign.progress + '%'" :aria-valuenow="campaign.progress" aria-valuemin="0" aria-valuemax="100"></div>
				</div>
			</div>
		</div>
		<div class="d-flex pt-2 pb-1 align-items-baseline">
			<div class="flex-grow-1 text-gray-500 font-weight-bold">
				<span v-if="showDetails && activeCampaigns.length > 5">+{{ activeCampaigns.length - 5 }} more</span>
			</div>
			<router-link :to="{ name: 'campaigns.index' }" class="btn btn-sm btn-ghost-primary">Manage Campaigns</router-link>
		</div>
	</div>
</section>
</template>



<script>
	import { mapState } from 'vuex';

	export default {
		data () {
			return {
				campaigns: {},
				current: moment(),
				showDetails: false,
			}
		},

		created() {
		},

		methods: {
			toggleDetails() {
				this.showDetails = !this.showDetails;
			},					
		},

		computed: {
			...mapState(['options']),

        	activeCampaigns() {
        		const filtered_campaigns = [];
				Object.keys(this.options.campaigns).forEach(key => {
					if (this.options.campaigns[key].status <= 1 || moment(this.current).diff(this.options.campaigns[key].ended_on, 'days') < 30) {
						filtered_campaigns.push(this.options.campaigns[key]);
					}						
				});
	    		return filtered_campaigns;

    		},

        	completedCampaigns() {		
        		const filtered_campaigns = [];
				Object.keys(this.options.campaigns).forEach(key => {
					if (this.options.campaigns[key].status == 2 || moment(this.current).diff(this.options.campaigns[key].ended_on, 'days') < 30) {
						filtered_campaigns.push(this.options.campaigns[key]);
					}						
				});
	    		return filtered_campaigns;
    		},
       		     		
		}

	}

</script>

<style>
</style>